<div class="sponsor" [class.generic]='isGeneric'>
  <div class="image-wrapper" (click)="navigateTo(sponsor?.linkUrl)">
    <img [src]="sponsor?.imageUrl" class="image" />
  </div>
</div>
